var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodyMp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Body_MP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Body_MP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4943817,33.0249618 C10.6164,32.2435295 10.7040571,31.6136545 10.7573529,31.1353366 C10.8372965,30.4178599 10.9735761,29.7645409 11.0132425,28.8018917 C11.052909,27.8392426 11.1825652,27.22895 11.0132425,25.3329481 C10.9003607,24.0689469 10.5934779,22.5622819 10.0925941,20.812953 C10.039907,21.1750498 9.94507532,21.5850886 9.80809906,22.0430694 C9.73340625,22.2928051 9.52560607,22.8226967 9.41162464,23.1485059 C9.3165799,23.4201856 9.20350239,23.6695893 9.20350239,24.3282648 C9.20350239,24.9869403 9.05058318,26.142502 8.65698672,27.5933318 C8.39458909,28.5605517 7.87691006,29.9183346 7.10394965,31.6666806 C6.88819915,32.2938314 6.79302016,32.7465918 6.81841268,33.0249618 C6.8438052,33.3033317 6.96428731,33.7011973 7.17985902,34.2185585 C7.26711724,34.4309823 4.88626026,34.9193517 5.15878078,33.270382 L5.27135647,30.5961153 C5.22263106,29.0243758 5.28497574,27.6946925 5.45839052,26.6070653 C5.6318053,25.5194382 6.03769952,23.9124091 6.67607319,21.7859781 C6.95367559,20.749227 7.13913066,19.9110785 7.23243841,19.2715327 C7.32574615,18.6319868 7.41828653,17.5647111 7.51005953,16.0697056 C7.46339472,14.9481576 7.67224697,14.0508661 8.13661627,13.3778312 C8.60098556,12.7047963 9.22902775,12.3891325 10.0207428,12.4308399 C10.274495,12.3802135 10.4581404,12.3384254 10.5716791,12.3054755 C10.7419871,12.2560506 11.574794,11.7931549 11.8896626,11.6459537 C12.2045312,11.4987525 13.0712858,11.226157 13.2954173,11.0908945 C13.4448384,11.0007196 13.6591197,10.835394 13.9382615,10.5949178 C13.9878344,10.5307155 14.0199938,10.3670156 14.0347396,10.1038182 C14.0494855,9.84062075 14.0494855,9.43031048 14.0347396,8.8728874 C13.945352,8.84880948 13.8669597,8.69805324 13.7995626,8.42061869 C13.7321656,8.14318414 13.673758,7.73081466 13.6243399,7.18351025 C13.2617413,7.05907256 13.0514649,6.86234783 12.9935106,6.59333604 C12.9583984,6.43035261 12.9318487,6.04722352 12.9935106,5.82893364 C13.0202532,5.73426179 13.1208888,5.67685735 13.2954173,5.65672031 C13.1412487,4.41659942 13.2202615,3.56801105 13.5324559,3.11095522 C13.7160646,2.84215019 14.0626687,2.37397223 14.6001358,2.07836251 C14.8510701,1.94034732 15.3370497,1.75 16,1.75 C16.6629503,1.75 17.1489299,1.94034732 17.3998642,2.07836251 C17.9373313,2.37397223 18.2839354,2.84215019 18.4675441,3.11095522 C18.7797385,3.56801105 18.8587513,4.41659942 18.7045827,5.65672031 C18.8791112,5.67685735 18.9797468,5.73426179 19.0064894,5.82893364 C19.0681513,6.04722352 19.0416016,6.43035261 19.0064894,6.59333604 C18.9485351,6.86234783 18.7382587,7.05907256 18.3756601,7.18351025 C18.326242,7.73081466 18.2678344,8.14318414 18.2004374,8.42061869 C18.1330403,8.69805324 18.054648,8.84880948 17.9652604,8.8728874 C17.9505145,9.43031048 17.9505145,9.84062075 17.9652604,10.1038182 C17.9800062,10.3670156 18.0121656,10.5307155 18.0617385,10.5949178 C18.3408803,10.835394 18.5551616,11.0007196 18.7045827,11.0908945 C18.9287142,11.226157 19.7954688,11.4987525 20.1103374,11.6459537 C20.425206,11.7931549 21.2580129,12.2560506 21.4283209,12.3054755 C21.5418596,12.3384254 21.725505,12.3802135 21.9792572,12.4308399 C22.7709722,12.3891325 23.3990144,12.7047963 23.8633837,13.3778312 C24.327753,14.0508661 24.5366053,14.9481576 24.4899405,16.0697056 C24.5817135,17.5647111 24.6742538,18.6319868 24.7675616,19.2715327 C24.8608693,19.9110785 25.0463244,20.749227 25.3239268,21.7859781 C25.9623005,23.9124091 26.3681947,25.5194382 26.5416095,26.6070653 C26.7150243,27.6946925 26.7773689,29.0243758 26.7286435,30.5961153 L26.8412192,33.270382 C27.1137397,34.9193517 24.7328828,34.4309823 24.820141,34.2185585 C25.0357127,33.7011973 25.1561948,33.3033317 25.1815873,33.0249618 C25.2069798,32.7465918 25.1118009,32.2938314 24.8960504,31.6666806 C24.1230899,29.9183346 23.6054109,28.5605517 23.3430133,27.5933318 C22.9494168,26.142502 22.7964976,24.9869403 22.7964976,24.3282648 C22.7964976,23.6695893 22.6834201,23.4201856 22.5883754,23.1485059 C22.4743939,22.8226967 22.2665937,22.2928051 22.1919009,22.0430694 C22.0549247,21.5850886 21.960093,21.1750498 21.9074059,20.812953 C21.4065221,22.5622819 21.0996393,24.0689469 20.9867575,25.3329481 C20.8174348,27.22895 20.947091,27.8392426 20.9867575,28.8018917 C21.0264239,29.7645409 21.1627035,30.4178599 21.2426471,31.1353366 C21.2959429,31.6136545 21.3836,32.2435295 21.5056183,33.0249618 C21.7576028,35.0441109 10.2423972,35.0441109 10.4943817,33.0249618 Z",
    id: "background",
    fill: "#8596A1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "13.3746256 3.38020823 13.1557996 4.21082559 18.6966268 4.83769903 18.6966268 4.21082559"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "13.1557996 4.54386324 13.1557996 5.32609539 18.6966268 5.61444425 18.6966268 4.83769903"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "10.2238698 20.9347198 10.2238698 19.6303298 21.8298479 19.6303298 21.9066496 20.9347198"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "10.3338991 20.4463013 10.4797473 21.5770556 21.5697857 22.0635479 21.8861596 20.9347198"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "7.02764686 20.3806829 10.2238698 21.090239 9.9167475 22.0635479 6.81314305 21.2549246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "6.81314305 21.2549246 6.59438131 21.8884388 9.55803298 23.2239323 9.9167475 22.0635479"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "6.67144806 21.86218 6.40598987 22.6034499 9.34834463 23.7774014 9.55803298 23.2239323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "9.34834463 23.7774014 6.04884559 23.7774014 5.83942521 24.5910751 9.18968911 24.4591034"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "5.7708645 24.5910751 5.61197383 25.3631498 9.18968911 24.9934254 9.18968911 24.1911685"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "5.61197383 25.3631498 5.45173684 26.2693057 9.06725923 25.9865447 9.18968911 24.9934254"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "10.2381465 21.5770556 10.5310696 22.8329201 21.385888 22.8329201 21.5751289 22.0635479"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "11.440745 11.8483681 10.4797473 12.2637511 10.2238698 17.5303972 10.5910104 17.484988"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "10.3557998 17.5303972 10.5310696 12.2527201 9.76494268 12.4113268 10.0646173 17.6173888"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "10.1982474 16.1265409 7.47569601 16.1265409 7.416835 16.749506 10.2238698 16.749506"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "7.36462759 16.749506 7.31685592 17.6173888 10.2238698 17.3016388 10.1982474 16.749506"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "7.31685592 17.6074393 7.21614727 18.5736394 10.3059881 17.6074393 10.0222152 17.3516825"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyMp);
export default __webpack_public_path__ + "static/media/Body_MP.9e903b81178d5422bb40051304936137.svg";
export { ForwardRef as ReactComponent };